import { render, staticRenderFns } from "./table_bf.vue?vue&type=template&id=73f26c04&scoped=true"
import script from "./table_bf.vue?vue&type=script&lang=js"
export * from "./table_bf.vue?vue&type=script&lang=js"
import style0 from "./table_bf.vue?vue&type=style&index=0&id=73f26c04&prod&lang=less&scoped=true"
import style1 from "./table_bf.vue?vue&type=style&index=1&id=73f26c04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f26c04",
  null
  
)

export default component.exports